import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=2d20bfbe&scoped=true"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"
import style0 from "./Management.vue?vue&type=style&index=0&id=2d20bfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20bfbe",
  null
  
)

export default component.exports